import { FETCH_HASHTAGS_SUCCESS } from "../actions";
import { defaultResultsByName } from "./sampleResults";

export const defaultState = {
  // ...defaultResultsByName
};

const results = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_HASHTAGS_SUCCESS:
      const output = action.items.reduce((obj, item) => {
        obj[item.name] = {
          id: item.id,
          hashtag: item.name,
          media_count: item.media_count
        };
        return obj;
      }, {});
      return output;
    default:
      return state;
  }
};

export default results;



// WEBPACK FOOTER //
// ./src/reducers/results.js